module.exports = __webpack_public_path__ + "img/hiddenGems.fb40ad39.svg";